<template>
  <DynamicModal
    :showModal="showEditModal"
    :persistent="false"
    @clickOutside="closeModal"
    title="Edit Tier"
    maxWidth="600px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="editTierForm">
        <v-row class="mt-3">
          <v-col cols="12">
            <CommissionTierInput
              :minAmount="minAmountToEdit"
              :maxAmount="maxAmountToEdit"
              :commissionPercent="commissionPercentToEdit"
              @minAmountChange="(newValue) => this.minAmountToEdit = newValue"
              @maxAmountChange="(newValue) => this.maxAmountToEdit = newValue"
              @commissionPercentChange="(newValue) => this.commissionPercentToEdit = newValue"
            ></CommissionTierInput>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="editTier"
          >
            Edit
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import DynamicModal from '@/components/dialogs/DynamicModal'
import { SimplePageHeader } from '@/components/pageComponents'
import CommissionTierInput from '@/components/commissionTiers/CommissionTierInput'

export default {
  components: {
    DynamicModal,
    SimplePageHeader,
    CommissionTierInput
  },
  data () {
    return {
      showEditModal: false,
      id: null,
      minAmountToEdit: null,
      maxAmountToEdit: null,
      commissionPercentToEdit: null
    }
  },
  methods: {
    showModal (tier) {
      this.id = tier.id
      this.minAmountToEdit = tier.minAmount
      this.maxAmountToEdit = tier.maxAmount
      this.commissionPercentToEdit = tier.commissionPercent
      this.showEditModal = true
    },
    closeModal () {
      this.clearTier()
      this.showEditModal = false
    },
    clearTier () {
      this.minAmountToEdit = null
      this.maxAmountToEdit = null
      this.commissionPercentToEdit = null
      this.$refs.editTierForm.resetValidation()
    },
    editTier () {
      if (this.$refs.editTierForm.validate()) {
        let tier = {
          id: this.id,
          minAmount: this.minAmountToEdit,
          maxAmount: this.maxAmountToEdit,
          commissionPercent: this.commissionPercentToEdit
        }
        this.$emit('editTier', tier)
        this.clearTier()
        this.showEditModal = false
      }
    }
  }
}
</script>
